import {EntityData, field} from "@fedeltapointofsale/data-client";

export class PurchaseOrderData extends EntityData<PurchaseOrderData> {
    @field orderId: number;
}
